/**
 * Controls footer padding when a sticky CTA bar is present
 */

const footer = document.querySelector('footer.footer');
const footerStickyBar = document.querySelector('.footer-sticky-bar');

((window) => {
  if (footer && footerStickyBar) {
    let scrolledPast = false;

    function adjustFooterPadding() {
      footer.style.paddingBottom = footerStickyBar.offsetHeight + "px";
    }

    // Show CTA when scrolled 300px
    function checkScrollPosition() {
      if (!scrolledPast && window.scrollY > 300) {
        scrolledPast = true;
        footerStickyBar.classList.add('active');
      } else if (scrolledPast && window.scrollY <= 300) {
        scrolledPast = false;
        footerStickyBar.classList.remove('active');
      }
    }

    // Run once on load
    adjustFooterPadding();
    checkScrollPosition();

    // Check position on scroll
    window.addEventListener('scroll', checkScrollPosition, { passive: true });

    // Observe element resize
    const resizeObserver = new ResizeObserver(adjustFooterPadding);
    resizeObserver.observe(footerStickyBar);
  }
})(window);